<template>
  <b-row>
    <b-col>
      <b-form-group :label="trans('title')">
        <b-form-input v-model="title" />
      </b-form-group>
      <b-form-group :label="trans('button_text')">
        <b-form-input v-model="btn_txt" :placeholder="trans('button_text')" />
      </b-form-group>
      <b-form-group :label="trans('note') + ' (' + trans('optional').toLowerCase() + ')'">
        <b-form-textarea v-model="note" />
      </b-form-group>
    </b-col>
    <b-col>
      <div id="placeholder-inputs">
        <b-form-group :label="trans('zoom_meeting_url')">
          <b-form-input v-model="zoom_meeting_url" placeholder="https://zoom.us/j/123456789" :class="use_as_placeholder ? 'placeholder' : ''" />
        </b-form-group>
        <b-form-group :label="trans('zoom_meeting_id')">
          <b-form-input v-model="zoom_meeting_id" placeholder="123 456 7890" :class="use_as_placeholder ? 'placeholder' : ''" />
        </b-form-group>
        <b-form-group v-if="!use_as_placeholder" :label="trans('zoom_meeting_password')">
          <b-form-input v-model="zoom_meeting_password" name="zoom_meeting_password" placeholder="" :class="use_as_placeholder ? 'placeholder' : ''" />
        </b-form-group>
        <p v-if="use_as_placeholder" class="text-muted">
          {{ trans('placeholder_zoom_meeting_password') }}
        </p>
      </div>
      <b-form-group>
        <b-form-checkbox switch v-model="use_as_placeholder">
          {{ trans('zoom_use_as_placeholder') }}
          <small class="text-muted" :title="trans('zoom_use_as_placeholder_about')" v-b-tooltip.hover>
            <i class="fa fa-fw fa-info-circle"></i>
          </small>
        </b-form-checkbox>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<style>
  #placeholder-inputs input.placeholder::first-line {
    background-color: #FFFF00;
  }
  #placeholder-inputs input[name=zoom_meeting_password].placeholder::first-line {
    background-color: inherit;
  }
</style>

<script>
  function deserialize(txt) {
    let $txt = $(`<div>${txt}</div>`)
    return {
      title: $txt.find('h2').text(),
      zoom_meeting_url: $txt.find('a').attr('href'),
      zoom_meeting_id: $txt.find('h3').text(),
      zoom_meeting_password: $txt.find('h4').text(),
      note: $txt.find('i').text(),
    }
  }

  export default {
    props: {
      organization: Object,
      type: {
        type: String,
        default: 'zoom',
      },
      image_url: String,
      image_alt: String,
      image_cta_url: String,
      image_percent: {
        type: Number,
        default: 0.5,
      },
      button_text: String,
      button_url: String,
      text: String,
    },
    data() {
      let data = deserialize(this.text)
      return {
        trans: trans,
        busy: false,
        error: null,
        file: null,
        img_url: this.image_url,
        img_alt: this.image_alt,
        img_cta_url: this.image_cta_url,
        img_percent: this.image_percent,
        btn_txt: this.button_text || trans('start_zoom'),
        btn_url: this.button_url,
        title: data.title || trans('virtual_class_on_zoom'),
        zoom_meeting_id: data.zoom_meeting_id || null,
        zoom_meeting_url: data.zoom_meeting_url || null,
        zoom_meeting_password: data.zoom_meeting_password || null,
        note: data.note || trans('zoom_meeting_note'),
        use_as_placeholder: data.zoom_meeting_id && data.zoom_meeting_id.indexOf('{') === 0,
        old_zoom_meeting_id: null,
        old_zoom_meeting_url: null,
        old_zoom_meeting_password: null,
      }
    },
    computed: {
      txt() {
        return _.compact([
          `<h2>${this.title}</h2>`,
          `<p><a href="${this.zoom_meeting_url}">${this.zoom_meeting_url}</a></p>`,
          `<p style="margin-bottom:0;">${trans('meeting_id')}</p><h3 style="margin-top:0;">${this.zoom_meeting_id}</h3>`,
          !this.use_as_placeholder && this.zoom_meeting_password ? `<p style="margin-bottom:0;">${trans('meeting_password')}</p><h4 style="margin-top:0;">${this.zoom_meeting_password}</h4>` : null,
          this.note ? `<p><i>${this.note}</i></p>` : null,
        ]).join('')
      },
    },
    watch: {
      title() {
        this.$emit('text', this.txt)
      },
      zoom_meeting_url() {
        this.$emit('image_cta_url', this.zoom_meeting_url)
        this.$emit('button_url', this.zoom_meeting_url)
        this.$emit('text', this.txt)        
      },
      zoom_meeting_id() {
        this.$emit('text', this.txt)
      },
      zoom_meeting_password() {
        this.$emit('text', this.txt)
      },
      btn_txt() {
        this.$emit('button_text', this.btn_txt)
      },
      use_as_placeholder() {
        if (this.use_as_placeholder) {
          this.old_zoom_meeting_url = this.zoom_meeting_url
          this.old_zoom_meeting_id = this.zoom_meeting_id
          this.old_zoom_meeting_password = this.zoom_meeting_password
          this.zoom_meeting_url = trans('placeholder_zoom_meeting_url')
          this.zoom_meeting_id = trans('placeholder_zoom_meeting_id')
          this.zoom_meeting_password = trans('placeholder_zoom_meeting_password')
        } else {
          this.zoom_meeting_url = this.old_zoom_meeting_url
          this.zoom_meeting_id = this.old_zoom_meeting_id
          this.zoom_meeting_password = this.old_zoom_meeting_password
        }
      }
    },
    methods: {
      emit() {
        this.$emit('image_url', 'https://activitymessenger-assets-ca.s3.amazonaws.com/social/zoom-cloud.jpg')
        this.$emit('image_cta_url', this.zoom_meeting_url)
        this.$emit('image_percent', 0.5)
        this.$emit('button_text', this.btn_txt)
        this.$emit('button_url', this.zoom_meeting_url)
        this.$emit('text', this.txt)
      },
    },
    mounted() {
      window.zoomTabComponent = this
      this.$nextTick(() => {
        this.emit()
      })
    },
  }
</script>